// // CartContext.js (example)
// import React, { createContext, useState, useEffect } from 'react';
// import { getCartFromLocal, saveCartToLocal } from '../utils/cart';
// import { useDeleteCartByIdMutation, useGetCardDetailsByUseridQuery, useLazyGetCardDetailsByUseridQuery } from '../services/cartApi';
// import { skipToken } from '@reduxjs/toolkit/query';
// export const CartContext = createContext();

// export const CartProvider = ({ children }) => {
//     const [cart, setCart] = useState([]);
//     const customerId = window.localStorage.getItem('customer_id');
//     const isLoggedIn = !!customerId;
//    var [deleteCartfn]= useDeleteCartByIdMutation()
//    var [getAllCartDetailsfn]=useLazyGetCardDetailsByUseridQuery(customerId ? customerId : skipToken);
//    const { data: serverCart, isLoading } = useGetCardDetailsByUseridQuery(
//            customerId ? customerId : skipToken
//          );
    
//     useEffect(() => {
//             if (isLoggedIn && serverCart) {
//               setCart(serverCart.data);
//             } else {
//                 const localCart = getCartFromLocal();
//                 setCart(localCart);
//             }
//            // subtotal = currentCart.reduce((acc, item) => acc + item.quantity * item.sale_price, 0);
//         }, [isLoggedIn, serverCart]);

//     const addToCart = (product) => {
//         const updatedCart = [...cart];
//         const existing = updatedCart.find(p => p.product_id === product.product_id && p.unit_id === product.unit_id);
//         const qtyToAdd = product.quantity ?? 1;

//         if (existing) {
//             existing.quantity += qtyToAdd;
//         } else {
//             updatedCart.push({ ...product, quantity: qtyToAdd });
//         }
//         setCart(updatedCart);
//         saveCartToLocal(updatedCart);
//     };
 
//     const updateQuantity = (productId, unitId, quantity) => {
//       const updatedCart = cart?.map((item) => {
//         if (item.product_id === productId && item.unit_id === unitId) {
//           return { ...item, quantity };
//         }
//         return item;
//       });
//       setCart(updatedCart);
//       if(!isLoggedIn)
//       saveCartToLocal(updatedCart);
//     };

//     const removeFromCart = async(cartId, productId, unitId) => {
//       if (isLoggedIn && customerId) {
//         try {
//             await deleteCartfn(cartId).unwrap(); // delete from backend
//             const response = await getAllCartDetailsfn(customerId).unwrap(); // fetch updated cart
//             if (response?.data) {
//                 setCart(response.data); // ✅ set cart with new data
//             }
//         } catch (error) {
//             console.error("Error during cart removal:", error);
//         }
//     } else {
//         const updatedCart = cart.filter(
//             (item) => !(item.product_id === productId && item.unit_id === unitId)
//         );
//         setCart(updatedCart);
//         saveCartToLocal(updatedCart);
//     }
//     };

//     const clearCart = () => {
//     setCart([]);
//     //saveCartToLocal([]); // clear local storage as well
//     };

//     return (
//         <CartContext.Provider value={{ cart, setCart, addToCart, updateQuantity,removeFromCart,clearCart }}>
//             {children}
//         </CartContext.Provider>
//     );
// };







//CartContext.jsx
import React, { createContext, useEffect, useState, useCallback } from "react";
import { useLazyGetCardDetailsByUseridQuery,useDeleteCartByIdMutation } from '../services/cartApi'; // adjust path





export const CartContext = createContext({
  cart: [],
  setCart: () => {},
  addToCart: () => {},
  removeFromCart: () => {},
  updateQuantity: () => {},
  clearCart: () => {},
  syncCartWithServer: () => {},
});

const LOCAL_CART_KEY = "local_cart";

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try {
      const raw = localStorage.getItem(LOCAL_CART_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      console.error("Failed to read cart from localStorage", e);
      return [];
    }
  });



// RTK Query lazy hook to fetch server cart
  const [triggerGetCart, { data: serverCartData, isFetching: isFetchingServerCart, error: serverCartError }] =
    useLazyGetCardDetailsByUseridQuery();

  // When a user logs in (customer_id appears) or on mount, fetch cart from server
  useEffect(() => {
    const customerId = localStorage.getItem('customer_id');

    // Debug
    // console.log('CartProvider: detected customerId:', customerId);

    if (customerId) {
      // trigger the RTK query (ensure it's called with Number if backend expects number)
      triggerGetCart(Number(customerId))
        .unwrap()
        .then((res) => {
          // Inspect response shape — adjust if your API returns differently
          // console.log('triggerGetCart response:', res);
          if (res && res.data && Array.isArray(res.data)) {
            setCart(res.data);
          } else if (res && Array.isArray(res)) {
            // some APIs return array directly
            setCart(res);
          } else {
            // fallback: empty cart
            setCart([]);
          }
        })
        .catch((err) => {
          // console.error('Failed to fetch server cart:', err);
          // fallback to local cart (do not overwrite local guest cart automatically)
          // Option: setCart([]) or keep localCart; here we keep local cart as-is
        });
    } else {
      // if not logged in, keep local cart; no action required
      // console.log('CartProvider: no customerId — using local cart');
    }
    // re-run when customer_id changes
  }, [triggerGetCart, /* include nothing else so it runs on mount */]);

  // persist cart to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem(LOCAL_CART_KEY, JSON.stringify(cart));
    } catch (e) {
      // console.error("Failed to write cart to localStorage", e);
    }
  }, [cart]);

  // helper: immutably add or merge item
//   const addToCart = useCallback((newItem) => {
//     setCart((prev) => {
//       // attempt to merge by product_id+unit_id if exists
//       const idx = prev.findIndex(
//         (i) =>
//           String(i.product_id) === String(newItem.product_id) &&
//           String(i.unit_id) === String(newItem.unit_id)
//       );
//       if (idx === -1) {
//         return [...prev, newItem];
//       } else {
//         const copy = [...prev];
//         copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + newItem.quantity };
//         return copy;
//       }
//     });
//   }, []);

// Replace the existing addToCart in CartContext.jsx with this version:

const generateTempCartId = () => `temp-${Date.now()}-${Math.floor(Math.random() * 10000)}`;


const addToCart = useCallback((newItem = {}) => {
  const product_id = newItem.product_id ?? newItem.id;
  const unit_id = newItem.unit_id ?? newItem.unitId ?? newItem.unit;
  const qtyToAdd = Number(newItem.quantity ?? 1) || 1;

  if (!product_id) return;

  setCart((prev) => {
    const idx = prev.findIndex(
      (i) =>
        (i.cart_id && newItem.cart_id && String(i.cart_id) === String(newItem.cart_id)) ||
        (String(i.product_id) === String(product_id) && String(i.unit_id) === String(unit_id))
    );

    if (idx === -1) {
      // Capture the image from any possible key provided by the API
      const imagePath = newItem.product_img_200 ?? newItem.product_img_400 ?? newItem.product_img ?? newItem.image ?? "";

      const itemToInsert = {
        ...newItem,
        cart_id: newItem.cart_id ?? generateTempCartId(),
        product_id,
        unit_id,
        product_name: newItem.product_name ?? newItem.name ?? "",
        product_img_200: imagePath, // Normalize to this key
        mrp: Number(newItem.mrp ?? newItem.price ?? 0),
        sale_price: Number(newItem.sale_price ?? newItem.price ?? 0),
        gst_slab: Number(newItem.gst_slab ?? newItem.gst ?? 0),
        quantity: qtyToAdd,
      };
      return [...prev, itemToInsert];
    } else {
      const copy = [...prev];
      const existing = copy[idx];
      copy[idx] = { ...existing, quantity: Number(existing.quantity ?? 0) + qtyToAdd };
      return copy;
    }
  });
}, []);

  // update quantity for a specific cart item (by cart_id OR product+unit)
  const updateQuantity = useCallback((cart_id, product_id, unit_id, newQuantity) => {
    setCart((prev) =>
      prev.map((item) => {
        if (
          (cart_id !== undefined && String(item.cart_id) === String(cart_id)) ||
          (product_id !== undefined &&
            String(item.product_id) === String(product_id) &&
            String(item.unit_id) === String(unit_id))
        ) {
          return { ...item, quantity: Number(newQuantity) };
        }
        return item;
      })
    );
  }, []);

  // remove item by cart_id (preferred) or by product_id+unit_id fallback
  // const removeFromCart = useCallback(async (cart_id, product_id, unit_id) => {
  //   // store removed item (in case you want to rollback)
  //   let removedItem = null;
  //   setCart((prev) => {
  //     const filtered = prev.filter((item) => {
  //       const match =
  //         (cart_id !== undefined && String(item.cart_id) === String(cart_id)) ||
  //         (product_id !== undefined &&
  //           String(item.product_id) === String(product_id) &&
  //           String(item.unit_id) === String(unit_id));
  //       if (match) removedItem = item;
  //       return !match;
  //     });
  //     return filtered;
  //   });

  //   // Try to notify backend (optional). If you have a mutation hook (RTK Query) prefer using that instead of fetch.
  //   try {
  //     const customerId = localStorage.getItem("customer_id");
  //     if (customerId && cart_id) {
  //       // ADJUST URL to your backend route. This is a generic example.
  //       // If you use RTK Query, replace this fetch with your mutation call.
  //       await fetch(`deleteCartDetailsById/${cart_id}`, {
  //         method: "DELETE",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
  //         },
  //       });
  //     }
  //   } catch (err) {
  //     console.error("Failed to delete on server, consider refetching or rollback", err);
  //     // Option: rollback by re-inserting removedItem
  //     // setCart(prev => removedItem ? [...prev, removedItem] : prev);
  //   }
  // }, []);
const [deleteCartById] = useDeleteCartByIdMutation();

  const removeFromCart = useCallback(
  async (cart_id, product_id, unit_id) => {

    // 1️⃣ Update UI immediately
    setCart((prev) =>
      prev.filter(
        (item) =>
          !(
            (cart_id && String(item.cart_id) === String(cart_id)) ||
            (String(item.product_id) === String(product_id) &&
              String(item.unit_id) === String(unit_id))
          )
      )
    );

    // 2️⃣ Update DB using RTK Query
    if (cart_id) {
      try {
        await deleteCartById(cart_id).unwrap();
      } catch (err) {
        // console.error("Failed to delete cart item", err);
      }
    }
  },
  [deleteCartById]
);


  // clear cart (immutable)
  const clearCart = useCallback(() => {
    setCart([]);
    try {
      localStorage.removeItem(LOCAL_CART_KEY);
    } catch (e) {
      // console.error(e);
    }
  }, []);

  // optionally: sync cart from server into local state (user logged in)
  const syncCartWithServer = useCallback(async () => {
    try {
      const customerId = localStorage.getItem("customer_id");
      if (!customerId) return;

      // ADJUST URL to your backend endpoint for fetching cart by user
      const res = await fetch(`/api/cart/user/${customerId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
        },
      });
      if (!res.ok) return;
      const payload = await res.json();
      // assume payload.data is the array; modify if your API differs
      if (payload && Array.isArray(payload.data)) {
        setCart(payload.data);
      }
    } catch (err) {
      // console.error("Failed to sync cart from server", err);
    }
  }, []);

  return (
    <CartContext.Provider
      value={{
        cart,
        setCart,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        syncCartWithServer,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
